'use client';

import { FaRegUserCircle } from 'react-icons/fa';

import LoginModal from '@/components/LoginModal';
import UserAvatar from '@/components/UserAvatar';
import UserDropDown from '@/components/UserDropDown';
import { useTranslation } from '@/contexts/dictionaryContext';
import useUserContext from '@/hooks/useUserContext';

type Props = {
  variant?: 'default' | 'sideMenu';
};

export function LoginButton({ variant = 'default' }: Props) {
  const { isDefaultUser, isLoaded } = useUserContext();
  const {
    modals,
    userDropDown,
    newHeader: { sideMenu },
  } = useTranslation();

  if (!isLoaded) {
    return null;
  }

  if (variant === 'sideMenu') {
    const sideMenuTrigger = (
      <button
        type="button"
        className="flex items-center justify-center gap-2 uppercase text-sm text-graphite tracking-wide mx-auto">
        <FaRegUserCircle className="size-5 text-primary" />
        {sideMenu.myAccount}
      </button>
    );

    if (isDefaultUser) {
      return (
        <LoginModal dict={modals} isHeader>
          {sideMenuTrigger}
        </LoginModal>
      );
    }

    return <UserDropDown dict={userDropDown}>{sideMenuTrigger}</UserDropDown>;
  }

  if (isDefaultUser) {
    return <LoginModal dict={modals} isHeader />;
  }

  return (
    <UserDropDown dict={userDropDown}>
      <UserAvatar.Container>
        <UserAvatar.Root />
      </UserAvatar.Container>
    </UserDropDown>
  );
}
